import {ReactComponent as IconClose} from '#/components/icons/ico-close.svg';
import {ReactComponent as IconMenu} from '#/components/icons/ico-menu.svg';
import {UIStatusContext} from '#/contexts/ui-status-provider';
import {ClassName} from '#/utils/utils';
import {FunctionComponent, useContext} from 'react';

export const MenuButton: FunctionComponent<{mode: 'open' | 'close'} & ClassName> = ({className = '', mode}) => {
  const {toggleMenu} = useContext(UIStatusContext);

  const onClick = () => {
    toggleMenu();
  };

  return (
    <button
      className={`min-w-[24px] py-4 flex justify-center items-center group/menu-button ${className}`}
      onClick={onClick}
    >
      {mode === 'open' ? (
        <IconMenu className='group-hover/menu-button:fill-blue-600' />
      ) : (
        <IconClose className='stroke-transparent fill-white group-hover/menu-button:stroke-blue-600 group-hover/menu-button:fill-blue-600' />
      )}
    </button>
  );
};
